exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contentWrapper[data-v-15c0404f]{padding:30px 15px}.contentItem[data-v-15c0404f]{flex-grow:1;padding-bottom:3px;border-bottom:1px solid #989898}", ""]);

// exports
